var EventHandler = /** @class */ (function () {
    function EventHandler(fnc) {
        this.handlers = [];
        if (fnc != null) {
            this.handlers.push(fnc);
        }
    }
    EventHandler.Create = function (click) {
        if (click == null) {
            return new EventHandler();
        }
        if (typeof click === "function") {
            var res = new EventHandler();
            res.subscribe(click);
            return res;
        }
        return click;
    };
    EventHandler.prototype.subscribe = function (fnc) {
        this.handlers.push(fnc);
    };
    EventHandler.prototype.notify = function (val, val2) {
        for (var _i = 0, _a = this.handlers; _i < _a.length; _i++) {
            var h = _a[_i];
            h(val, val2);
        }
    };
    EventHandler.prototype.count = function () {
        return this.handlers.length;
    };
    EventHandler.prototype.unSubscribe = function (fnc) {
        if (this.handlers.indexOf(fnc) >= 0) {
            this.handlers.splice(this.handlers.indexOf(fnc), 1);
        }
        else {
            // TODO? throw exception?
            console.warn("handler not found in EventHandler.unSubscribe");
        }
    };
    return EventHandler;
}());
export { EventHandler };
